import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import CheckboxGroup from '../CheckboxGroup'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
}

/**
 * Connects the CheckboxGroup with Formik.
 */
function FormikCheckboxGroup(props) {
  const { id } = props

  return (
    <Field name={id}>
      {({ field, meta }) => (
        <CheckboxGroup
          {...props}
          id={id}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value}
          errors={meta.touched && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikCheckboxGroup.propTypes = propTypes

export default FormikCheckboxGroup
